{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "WhatsApp-Vorlagen",
      "SUBTITLE": "Wählen Sie die WhatsApp-Vorlage aus, die Sie senden möchten",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Vorlagen suchen",
      "NO_TEMPLATES_FOUND": "Keine Vorlagen gefunden für",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Kategorie",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Sprache",
        "TEMPLATE_BODY": "Vorlagenbody",
        "CATEGORY": "Kategorie"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Variablen",
      "LANGUAGE": "Sprache",
      "CATEGORY": "Kategorie",
      "VARIABLE_PLACEHOLDER": "Geben Sie den Wert {variable} ein",
      "GO_BACK_LABEL": "Zurück",
      "SEND_MESSAGE_LABEL": "Nachricht senden",
      "FORM_ERROR_MESSAGE": "Bitte füllen Sie vor dem Absenden alle Variablen aus",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
